/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TicketResaleResult { 
    /**
     * Id Hash. UTI (Unique Ticket Identifier). Identifier of the currently tickets resaled
     */
    idHashTickets?: Array<string>;
}

